export default function discountRates(state = [], action) {
  switch (action.type) {
    case 'FETCH_DISCOUNT_RATES_SUCCESS':
      return action.response
    default:
      return state
  }
}
